import { Axios } from '@src/app/context/Api/includes/Axios';
import { translateCriteria } from '@src/entities/ActionPath/includes/functions';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { isNil, isUndefined } from 'lodash';

/**
 * GetAggregationView
 *
 * @TODO Needs description.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const GetAggregationView = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      data: {
        aggregationFilter: '',
        researchAggregationId: '',
      },
      headers: {
        'x-api-endpoint': `/aggregation/playground`,
      },
      method: 'POST',
      params: { apiKey: theApiKey, queryKey: theQueryKey },
    };

    if (!isUndefined(thePayload?.view)) {
      requestArgs.data.researchAggregationId = thePayload?.view;
    }

    delete thePayload?.criteria?.entrance?.mergedStr;
    delete thePayload?.criteria?.exit?.mergedStr;

    if (!isNil(thePayload?.criteria)) {
      requestArgs.data.criteria = translateCriteria(thePayload?.criteria, 'outgoing');
    }

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/RiskRecord/api/requests/queries/GetAggregationView.js -> GetAggregationView()',
      false,
      error
    );

    throw error;
  }
};
